<template>
    <fb-form-body>
        <el-form :model="formData" :rules="rules" ref="form" label-width="100px" class="fb-form">

            <el-form-item label="用户账号" prop="account" :error="formErrorMsg.account">
                <el-input v-model="formData.account" disabled></el-input>
            </el-form-item>


            <el-form-item label="用户昵称" prop="nickname">
                <el-input v-model="formData.nickname"></el-input>
            </el-form-item>


            <el-form-item label="用户姓名" prop="realName">
                <el-input v-model="formData.realName"></el-input>
            </el-form-item>

            <el-form-item label="用户邮箱" prop="email">
                <el-input v-model="formData.email"></el-input>
            </el-form-item>

            <el-form-item label="手机号码" prop="mobile">
                <el-input v-model="formData.mobile"></el-input>
            </el-form-item>

            <el-form-item label="出生日期" prop="birthday">
                <el-date-picker
                        v-model="formData.birthday"
                        type="date"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                </el-date-picker>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="handleSubmit('form')">确定</el-button>
                <el-button @click="handleReset('form')">重置</el-button>
            </el-form-item>
        </el-form>
    </fb-form-body>
</template>

<script>
    export default {
        name: "UserAdd",
        components: {},
        data() {
            return {
                api:{
                   userInfo:this.$api.auth.userInfo,
                },
                formErrorMsg:{account:''},
                formData: {
                    code:'',
                    account: '',
                    nickname: '',
                    realName: '',
                    email: '',
                    mobile: '',
                    birthday: '',
                    status: '1',
                },
                rules: {
                    account: [
                        {required: true, message: '请输入用户账号', trigger: 'blur'},
                    ],
                    password: [
                        {required: true, message: '请输入用户密码', trigger: 'blur'},
                        { min: 6, max: 16, message: '密码长度在 6 到 16 个字符', trigger: 'blur' }
                    ],
                    nickname: [
                        {required: true, message: '请输入用户昵称', trigger: 'blur'}
                    ],

                }
            }
        },
        methods: {
            handleSubmit(form) {

                let vm = this;
                vm.$refs[form].validate((valid) => {
                    if (valid) {
                        vm.$http.post(vm.$api.auth.updateUserInfo,this.$qs.stringify(this.formData)).then((resp)=>{

                            if(resp.data.status === 200){
                                vm.$message({
                                    type:'success',
                                    message: resp.data.desc
                                });
                                vm.$router.cgBack();
                            }else if(resp.data.status === 400){
                                resp.data.data.errorFields.forEach(function (a) {

                                    vm.formErrorMsg[a.name] = '';
                                    vm.$nextTick(() => {
                                        vm.formErrorMsg[a.name] = a.message;
                                    });


                                });
                                vm.$message({
                                    type:"error",
                                    message: resp.data.desc
                                });
                            }else{
                                vm.$message({
                                    type:"error",
                                    message: resp.data.desc
                                })
                            }

                        });
                        return true;
                    } else {
                        return false;
                    }
                });

            },
            handleReset(form) {
                this.$refs[form].resetFields();
            }
        },

        created() {

            let vm = this;
            this.$http.post(this.api.userInfo).then(function (resp) {
                for(let key in resp.data.data){
                    for(let fKey in vm.formData){
                        vm.formData[fKey] = resp.data.data[key][fKey]

                        if(fKey === 'birthday' && vm.formData[fKey]){
                            vm.formData['birthday'] = vm.$moment(vm.formData[fKey]).format('YYYY-MM-DD');
                        }

                    }
                }
            });

        }
    }
</script>

<style lang="scss" scoped>

    .fb-form {
        max-width: 500px;
    }

</style>